import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Typography, CircularProgress, Box, Alert } from '@mui/material';
import { getAllProducts } from '../../../../services/menuPage';
import ProductList from './ProductList';
import ProductTable from './ProductTable';

const ProductTabs = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const data = await getAllProducts();
      setProducts(data);
      setError(null);
    } catch (err) {
      console.error("🚫 فشل في جلب المنتجات:", err.message);
      setError("فشل في تحميل المنتجات");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <Box sx={{ mt: 3 }}>
      <Tabs
        value={tabIndex}
        onChange={(e, newValue) => setTabIndex(newValue)}
        centered
        sx={{ mb: 2 }}
      >
        <Tab label="عرض كروت المنتجات" />
        <Tab label="عرض جدول المنتجات" />
      </Tabs>

    {tabIndex === 0 && (
  <ProductList
    products={products}
    loading={loading}
    error={error}
    refresh={fetchProducts}
  />
)}
{tabIndex === 1 && (
  <ProductTable
    products={products}
    loading={loading}
    error={error}
    refresh={fetchProducts}
  />
)}

      {loading && <CircularProgress />}
      {error && <Alert severity="error">{error}</Alert>}
    </Box>
  );
};

export default ProductTabs;
